// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"740":"5cf27fef","1660":"5cf27fef","5378":"edb30248"}[chunkId] + ".chunk.css";
};